import React from 'react';
import { SCREEN_SIZE } from 'types';
import { useSelector } from 'react-redux';
import { HeaderName } from 'carbon-components-react/lib/components/UIShell';
import { selectScreenSize } from 'redux/session/selectors';
import { ReactComponent as LogoBYDABig } from 'assets/images/byda/ui-custom-logos-byda-logo.svg';
import { ReactComponent as LogoBYDASmall } from 'assets/images/byda/ui-custom-logos-byda-symbol-md.svg';

const TopHeaderLogo: React.FC = () => {
  const screenSize = useSelector(selectScreenSize);

  return (
    <HeaderName className="globalHeaderBody-logo--wrapper" prefix="">
      {screenSize && screenSize === SCREEN_SIZE.SM ? (
        <LogoBYDASmall className="header-logo-img" />
      ) : (
        <LogoBYDABig className="header-logo-img" />
      )}
    </HeaderName>
  );
};

export default TopHeaderLogo;
